/**
 * @generated SignedSource<<58bb226aef462dfdd4ae76dd0cb6d40d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type addAreaBackgroundRulePanel_AreaBackgroundRulesListForAddQuery$variables = Record<PropertyKey, never>;
export type addAreaBackgroundRulePanel_AreaBackgroundRulesListForAddQuery$data = {
  readonly areaBackgroundRules: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
    readonly printTypeIDs: ReadonlyArray<number> | null;
  }>;
};
export type addAreaBackgroundRulePanel_AreaBackgroundRulesListForAddQuery = {
  response: addAreaBackgroundRulePanel_AreaBackgroundRulesListForAddQuery$data;
  variables: addAreaBackgroundRulePanel_AreaBackgroundRulesListForAddQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AreaBackgroundRuleTool",
    "kind": "LinkedField",
    "name": "areaBackgroundRules",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "printTypeIDs",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "addAreaBackgroundRulePanel_AreaBackgroundRulesListForAddQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "addAreaBackgroundRulePanel_AreaBackgroundRulesListForAddQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "0a924a9e07eb57caa38b15649b42736f",
    "id": null,
    "metadata": {},
    "name": "addAreaBackgroundRulePanel_AreaBackgroundRulesListForAddQuery",
    "operationKind": "query",
    "text": "query addAreaBackgroundRulePanel_AreaBackgroundRulesListForAddQuery {\n  areaBackgroundRules {\n    id\n    name\n    printTypeIDs\n  }\n}\n"
  }
};
})();

(node as any).hash = "3c70673814e44f92e32a5ad2848e48a4";

export default node;
